import React from "react";
import { Link } from "react-router-dom";

import "../css/homepage/normalize.css";
import "../css/homepage/webflow.css";
import "../css/homepage/usb-mainsite.webflow.css";

//import Hero images
import shape01 from "../images/home-hero-shape-01-defi-x-template-2.png";
import shape02 from "../images/home-hero-shape-02-defi-x-template.png";
import shape03 from "../images/home-hero-shape-03-defi-x-template.png";
import shape04 from "../images/home-hero-shape-04-defi-x-template.png";
import coin01 from "../images/home-hero-coin-01-defi-x-template.png";
import coin02 from "../images/home-hero-coin-02-defi-x-template.png";
import coin03 from "../images/home-hero-coin-03-defi-x-template.png";
import phoneApp01 from "../images/UniSafeBox_Phone.png";

import first01 from "../images/first.png";
import second02 from "../images/Screen-Shot-2023-05-30-at-1.40.23-AM.png";
import third03 from "../images/privateSecurity.png";
import fourth04 from "../images/DigitWorld.png";
import fifth05 from "../images/DigitLock.png";
import sixth06 from "../images/DigitBinary.png";
import iOSDownloadBtn from "../images/iOS_Download_Btn.svg";
import Android_Download_Btn from "../images/Android_Download_Btn.svg";

//CTA Image
import usbBannerRight from "../images/usb_banner_right.png";

//import indexgoogleplay from '../images/index-google-play.png';

//import QRCode from '../images/QRCode.png';
import defi_x_404 from "../images/404-1-defi-x-webflow-template-p-130x130q80.png";

export default function Home() {
  return (
    <>
      <div className="page-wrapper">
        <div
          data-collapse="medium"
          data-animation="over-right"
          data-duration={400}
          data-w-id="58db7844-5919-d71b-dd74-2323ed8dffe9"
          data-easing="ease"
          data-easing2="ease"
          role="banner"
          className="header w-nav"
        >
          <div className="container-default w-container">
            <div className="header-wrapper">
              <div
                data-w-id="a3e68005-48fe-fa9e-c964-745ec27593aa"
                className="split-content header-right"
              >
                <Link to="/" className="header-logo-link w-nav-brand">
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="header-logo-2"
                  />
                </Link>
              </div>
              <div className="split-content header-middle">
                <nav role="navigation" className="nav-menu-2 w-nav-menu">
                  <ul role="list" className="header-navigation">
                    <li className="nav-item-wrapper first">
                      <Link to="/" className="nav-link-2">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item-wrapper">
                      <Link to="/requestLink" className="nav-link-2">
                        Pay for USB
                      </Link>
                    </li>
                    <li className="nav-item-wrapper header-button-wrapper">
                      <div className="nav-button-wrapper">
                        <a
                          href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk"
                          className="button-primary-2 full-width w-button"
                        >
                          Download Now
                        </a>
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
              <div className="split-content header-left">
                <div className="nav-button-wrapper hide-in-mobile">
                  <a
                    href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk"
                    className="button-primary-2 small w-button"
                  >
                    Download Now
                  </a>
                </div>
                <div>
                  <input type="checkbox" id="menu-toggle" />
                  <label for="menu-toggle" class="hamburger-icon">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                  <nav id="mobile-nav">
                  <ul role="list" className="header-navigation">
                    <li className="nav-item-wrapper first">
                      <Link to="/" className="nav-link-2">
                        Home
                      </Link>
                    </li>
                    <li className="nav-item-wrapper">
                      <Link to="/requestLink" className="nav-link-2">
                        Pay for USB
                      </Link>
                    </li>
                    <li className="nav-item-wrapper header-button-wrapper">
                      <div className="nav-button-wrapper">
                        <a
                          href="https://finnovant.s3.amazonaws.com/UniSafeBox-Android.apk"
                          className="button-primary-2 full-width w-button"
                        >
                          Download Now
                        </a>
                      </div>
                    </li>
                  </ul>
                  </nav>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* */}
        <div id="HeroDiv" className="section home-hero wf-section">
          <div className="container-default">
            <div>
              <div className="grid-2-columns home-hero">
                <div id="w-node-_3703a796-c1cc-6e64-6534-574e523e9bb6-b2397b18">
                  <h1 className="heading">Safely Manage Your Digital Assets</h1>
                  <div className="inner-container-550px">
                    <p data-w-id="3703a796-c1cc-6e64-6534-574e523e9bba">
                      The UniSafeBox Blockchain Data manager combines double
                      encryption technology with blockchain encryption
                      algorithms to secure your most sensitive information.
                      <br />
                      <br />
                      To make it even more secure, Unisafebox access is secured
                      by Say-Tec, Finnovant's biometric authentication solution.
                    </p>
                  </div>
                  <div className="_2-button-wrap mg-top-48px">
                    <img
                      src={iOSDownloadBtn}
                      loading="lazy"
                      width={175}
                      alt=""
                      className="image-10"
                    />
                    <img
                      src={Android_Download_Btn}
                      loading="lazy"
                      width={175}
                      alt=""
                      className="image-10"
                    />
                  </div>
                </div>
                <div className="image-wrapper home-hero-image">
                  <div
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9bc2"
                    className="home-hero-shapes---a"
                  >
                    <img
                      src={shape01}
                      alt=""
                      width={198}
                      className="shape home-hero shape---01"
                    />
                    <img
                      src={shape02}
                      alt=""
                      className="shape home-hero shape---02"
                    />
                    <img
                      src={shape03}
                      alt=""
                      className="shape home-hero shape---03"
                    />
                    <img
                      src={shape04}
                      alt=""
                      className="shape home-hero shape---04"
                    />
                  </div>
                  <div
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9bc7"
                    className="home-hero-shapes---b"
                  >
                    <img
                      src={coin01}
                      alt=""
                      className="shape home-hero coin---01"
                    />
                    <img
                      src={coin02}
                      alt=""
                      className="shape home-hero coin---02"
                    />
                    <img
                      src={coin03}
                      alt=""
                      className="shape home-hero coin---03"
                    />
                  </div>
                  <img
                    src={phoneApp01}
                    sizes="(max-width: 479px) 93vw, (max-width: 767px) 94vw, (max-width: 991px) 62vw, 550px"
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9bcb"
                    alt=""
                    className="home-hero bg"
                  />
                  <img
                    src="images/blob-01-defi-x-template.png"
                    sizes="(max-width: 991px) 100vw, (max-width: 1919px) 1101.50439453125px, 57vw"
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9bcc"
                    alt=""
                    className="blob home-hero"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div id="USB_Features" className="section tabs wf-section">
          <div className="container-default w-container">
            <div>
              <div className="inner-container-450px center-content text-center mg-bottom-large-80px">
                <h2 data-w-id="3703a796-c1cc-6e64-6534-574e523e9c16">
                  UniSafeBox <br />
                  Password Manager
                </h2>
                <p
                  data-w-id="3703a796-c1cc-6e64-6534-574e523e9c18"
                  className="mg-bottom-0px"
                >
                  <strong>
                    Key Features:
                    <br />
                  </strong>
                  <span className="text-span">
                    UniSafeBox remembers your critical information so you don't
                    have to.
                  </span>
                </p>
              </div>
              <div className="usb-feat1">
                <ul role="list" className="list">
                  <li>Passwords</li>
                  <li>Bankcards</li>
                  <li>Digital Wallet Information</li>
                  <li>Photos &amp; Videos</li>
                  <li>Music</li>
                  <li>Important Documents</li>
                  <li>Blockchain Encryption</li>
                  <li>Data Encryption</li>
                  <li>Biometric Security</li>
                  <li>Provides BioFi Utility Usage Points</li>
                  <li>Embedded in the Phenix X1</li>
                  <li>
                    Inheritance - Pass on your most valuable treasures to your
                    heir or an approved agent
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="section tabs wf-section">
          <div className="container-default w-container">
            <div className="usb_main">
              <div className="usbdesccont_odd">
                <div className="usb_ft_lft">
                  <img
                    src={first01}
                    loading="lazy"
                    sizes="(max-width: 767px) 84vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_rt">
                  <h3>Biometric Identification</h3>
                  <p>
                    Your personal biometric factors are securely stored and
                    utilized for authentication to unlock and provide access to
                    your private key. Powered by Say-Tec{" "}
                  </p>
                </div>
              </div>
              <div className="usbdesccont_even">
                <div className="usb_ft_lft">
                  <h3>Safe management of Digital Assets</h3>
                  <p>
                    Your digital assets are safely stored in a secure safe box,
                    ready for immediate access.
                  </p>
                </div>
                <div className="usb_ft_rt">
                  <img
                    src={second02}
                    loading="lazy"
                    sizes="(max-width: 767px) 100vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
              </div>
              <div className="usbdesccont_mobi">
                <div className="usb_ft_rt">
                  <img
                    src={second02}
                    loading="lazy"
                    sizes="(max-width: 479px) 72vw, (max-width: 767px) 77vw, 100vw"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_lft">
                  <h3>Safe management of Digital Assets</h3>
                  <p>
                    Your digital assets are safely stored in a secure safe box,
                    ready for immediate access.
                  </p>
                </div>
              </div>
              <div className="usbdesccont_odd">
                <div className="usb_ft_lft">
                  <img
                    src={third03}
                    loading="lazy"
                    sizes="(max-width: 767px) 84vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_rt">
                  <h3>Private Key Security</h3>
                  <p>
                    Enhanced security features ensure both the security and
                    usability of the Krptic wallet.
                  </p>
                </div>
              </div>
              <div className="usbdesccont_even">
                <div className="usb_ft_lft">
                  <h3>DeFi - Decentralized Finance</h3>
                  <p>
                    Web 3 enhanced browser provides greater ease of usecontrol
                    of your assets with a high level of security.
                  </p>
                </div>
                <div className="usb_ft_rt">
                  <img
                    src={fourth04}
                    loading="lazy"
                    sizes="(max-width: 767px) 100vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
              </div>
              {/* Moibile version */}
              <div className="usbdesccont_mobi">
                <div className="usb_ft_rt">
                  <img
                    src={fourth04}
                    loading="lazy"
                    sizes="(max-width: 479px) 72vw, (max-width: 767px) 77vw, 100vw"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_lft">
                  <h3>DeFi - Decentralized Finance</h3>
                  <p>
                    Web 3 enhanced browser provides greater ease of usecontrol
                    of your assets with a high level of security.
                  </p>
                </div>
              </div>
              <div className="usbdesccont_odd">
                <div className="usb_ft_lft">
                  <img
                    src={fifth05}
                    loading="lazy"
                    sizes="(max-width: 767px) 84vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_rt">
                  <h3>Regulation and Privacy</h3>
                  <p>Globally compliant and user friendly.</p>
                </div>
              </div>
              <div className="usbdesccont_even">
                <div className="usb_ft_lft">
                  <h3>DeFi - Decentralized Finance</h3>
                  <p>
                    Web 3 enhanced browser provides greater ease of usecontrol
                    of your assets with a high level of security.
                  </p>
                </div>
                <div className="usb_ft_rt">
                  <img
                    src={sixth06}
                    loading="lazy"
                    sizes="(max-width: 767px) 100vw, (max-width: 1439px) 43vw, 558.8984375px"
                    alt=""
                    className="image-11"
                  />
                </div>
              </div>
              <div className="usbdesccont_mobi">
                <div className="usb_ft_rt">
                  <img
                    src={sixth06}
                    loading="lazy"
                    sizes="(max-width: 479px) 72vw, (max-width: 767px) 77vw, 100vw"
                    alt=""
                    className="image-11"
                  />
                </div>
                <div className="usb_ft_lft">
                  <h3>DeFi - Decentralized Finance</h3>
                  <p>
                    Web 3 enhanced browser provides greater ease of usecontrol
                    of your assets with a high level of security.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="cta-section wf-section">
          <div className="container-default w-container">
            <div
              data-w-id="3703a796-c1cc-6e64-6534-574e523e9d9f"
              className="cta-main-wrapper"
            >
              <div className="cta-wrapper">
                <div className="image-wrapper relative">
                  <img
                    src={usbBannerRight}
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9da6"
                    alt=""
                    className="image cta-image"
                  />
                </div>
                <div className="cta-content">
                  <h2
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9da8"
                    className="mg-bottom-8px"
                  >
                    Secure your assets today!
                  </h2>
                  <p
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9daa"
                    className="mg-bottom-24px"
                  >
                    Get started by downloading UniSafeBox.
                  </p>
                  <div
                    data-w-id="3703a796-c1cc-6e64-6534-574e523e9dac"
                    className="_2-button-wrap center-t"
                  >
                    <a
                      href="#HeroDiv"
                      className="button-primary button-white _2-buttons w-button"
                    >
                      Download Now!
                    </a>
                    <a
                      href="#USB_Features"
                      className="button-secondary white w-button"
                    >
                      Learn more
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <footer className="footer">
          <div className="container-default">
            <div className="w-layout-grid footer-grid">
              <div
                id="w-node-_545d2dbf-8143-2662-0998-a356a1027525-ae2f46c5"
                className="footer-column"
              >
                <a
                  href="#"
                  className="footer-logo-container mg-bottom-24px w-inline-block"
                >
                  <img
                    src={require("../images/UniSafeBox_Logo.png")}
                    alt=""
                    className="footer-logo"
                  />
                </a>
                <p className="mg-bottom-32px">
                  Secure your assets with UniSafeBox Powered Biometric
                  Financial.
                  <br />
                </p>
                <div className="social-links-wrapper" />
              </div>
              <div
                id="w-node-_8f0dde0c-ad87-3903-db5c-1a8dc74f8208-ae2f46c5"
                className="footer-column middle"
              >
                <div className="footer-nav-main-wrapper">
                  <div className="footer-nav-wrapper">
                    <ul role="list" className="footer-nav" />
                  </div>
                </div>
              </div>
            </div>
            <div className="divider bg-neutral-600" />
            <div className="footer-bottom-content">
              <div>
                Copyright © 2023 UniSafeBox - powered by{" "}
                <a href="https://www.biometricfinancial.org" alt="Biofi">
                  Biometric Financial
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </>
  );
}
